import React from 'react';
import styled from "styled-components";
const IndexHeader = styled.div`
display: flex;
grid-template-columns: 1fr;
grid-template-rows: 1fr;
align-items: left;
justify-items: left;
padding-bottom: 50%;

.image {
  //min-height: 85vh;
  width: 70%;
  grid-column: 1/1;
  grid-row: 1/1;
  padding-bottom : 40px;
}
`;
const HomeHeader = ({img}) => {
    return (
        <IndexHeader>
            <img src={img} alt={"KYC document exchange"} className="image" />
        </IndexHeader>
    );
};

export default HomeHeader;
